// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_AT_RULE_IMPORT_0___ = require("-!../../../../node_modules/css-loader/dist/cjs.js!@unite-us/app-components/dist/styles/tailwind.css");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
exports.push([module.id, ".facesheet-sub-header__title-row{margin-top:15px;margin-bottom:40px}.facesheet-sub-header__title-summary{display:flex;align-items:center}.facesheet-sub-header__refer-button-container{display:flex;align-items:center;justify-content:flex-end;height:100%}@media only screen and (max-width: 768px){.facesheet-sub-header .refer-button{margin-top:10px}}", ""]);
// Exports
module.exports = exports;
